import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from "@dp/state";
import { Box, HStack, Pressable } from "native-base";
import { observer } from "mobx-react-lite";
import BrandIcon from "../BrandIcon";
import { isTrue } from "@dp/common";

var JoinWaitlistConfirmationHeader = function JoinWaitlistConfirmationHeader() {
  var _store$styleCode, _store$common;

  var store = useStore();
  var isMobile = store === null || store === void 0 ? void 0 : store.isMobile;
  var brand = store === null || store === void 0 ? void 0 : (_store$styleCode = store.styleCode) === null || _store$styleCode === void 0 ? void 0 : _store$styleCode.toUpperCase();
  var isGlobalBannerMsgEnabled = store === null || store === void 0 ? void 0 : (_store$common = store.common) === null || _store$common === void 0 ? void 0 : _store$common.shouldShowGlobalBanner;
  return /*#__PURE__*/_jsxs(HStack, {
    _ios: {
      height: isTrue(isMobile, 20, 24)
    },
    _android: {
      height: isTrue(isMobile, 20, 24)
    },
    _web: {
      position: "fixed",
      top: isTrue(isGlobalBannerMsgEnabled, "40px", 0),
      height: isTrue(isMobile, "77px", "91px")
    },
    justifyContent: "center",
    alignItems: "center",
    w: "100%",
    borderBottomWidth: 1,
    borderBottomColor: "#D6D6D6",
    bg: isTrue(isMobile, "headerBackgroundTop", "headerBackground"),
    children: [/*#__PURE__*/_jsx(Box, {
      pl: isMobile ? 0 : 3,
      position: "absolute",
      left: 5,
      children: /*#__PURE__*/_jsx(Pressable, {
        onPress: function onPress() {
          var _store$joinWaitlist;

          store === null || store === void 0 ? void 0 : (_store$joinWaitlist = store.joinWaitlist) === null || _store$joinWaitlist === void 0 ? void 0 : _store$joinWaitlist.redirectToRestDetails();
        },
        children: /*#__PURE__*/_jsx(BrandIcon, {
          iconName: "jw-header-arrow",
          alt: "back-arrow",
          w: "5",
          h: "5"
        })
      })
    }), /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Pressable, {
        onPress: function onPress() {
          var _store$platformUtil;

          store === null || store === void 0 ? void 0 : (_store$platformUtil = store.platformUtil) === null || _store$platformUtil === void 0 ? void 0 : _store$platformUtil.navigateToRoute("/home");
        },
        children: /*#__PURE__*/_jsx(BrandIcon, {
          alt: brand,
          iconName: "brand-logo",
          _ios: {
            height: 16,
            width: 48
          },
          _android: {
            height: 16,
            width: 48
          },
          _web: {
            height: "57px",
            width: "190px"
          }
        })
      })
    })]
  });
};

export default observer(JoinWaitlistConfirmationHeader);